module.exports = __webpack_public_path__ + "img/dt1.54a60ef6.png";